<form-popup [width]="520" 
            [(visible)]="visible" 
            (visibleChange)="onVisibleChange($event)"
            (save)="onPopupSaveClick()" 
            titleText="Compliance">
    <compliance-form [formData]="formData" [showTrailerRequired]="true"></compliance-form>
</form-popup>